import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {ApiService} from './api.service';
import {mergeMap} from 'rxjs/operators';

@Injectable()
export class MeetingService {
  constructor(private apiService: ApiService) {
  }

  public getMeetingDetails(meetingId): Observable<IMeetingDetails> {
    return this.apiService.getMeetingDetails(meetingId).pipe(
      mergeMap((res: IMeetingDetails) => {
        const typeOrg = 'organizer';
        res.attendees = res.attendees.sort((a, b) => {
          if (a.type.toLowerCase() === typeOrg) {
            return -1;
          }
          if (b.type.toLowerCase() === typeOrg) {
            return 1;
          }
          return 0;
        });
        return of(res);
      })
    );
  }

}

export interface IMeetingDetails {
  id: string;
  subject: string;
  isAllDay: boolean;
  isCancelled: boolean;
  onlineMeetingUrl: string;
  isOnlineMeeting: boolean;
  onlineMeetingProvider: string;
  responseStatus: IMeetingResponse;
  start: string;
  end: string;
  location: string;
  attendees: IMeetingDetailsAttend[];
  onlineMeeting: IMeetingOnlineMeeting;
  body: {
    contentType: string;
    content: string;
  };
  organizer?: IMeetingDetailsAttend;
}

export interface IMeetingDetailsAttend {
  attendedId: string;
  emailAddress: IMeetingEmailAddress;
  status: IMeetingResponse;
  type: string;
}

export interface IMeeting {
  id: string;
  subject: string;
  bodyPreview: string;
  isAllDay: boolean;
  isCancelled: boolean;
  onlineMeetingUrl: string;
  isOnlineMeeting: boolean;
  onlineMeetingProvider: string;
  responseStatus: IMeetingResponse;
  start: string;
  end: string;
  location: string;
  organizer: IMeetingOrganizer;
  onlineMeeting: IMeetingOnlineMeeting;
  singleValueExtendedProperties: string;
}

export interface IMeetingOnlineMeeting {
  joinUrl: string;
  dialInNumber: string;
}

export interface IMeetingEmailAddress {
  name: string;
  address: string;
}

export interface IMeetingOrganizer {
  emailAddress: IMeetingEmailAddress;
}

export interface IMeetingDate {
  dateTime: string;
  timeZone: string;
}

export interface IMeetingResponse {
  response: string;
  time: string;
  icon?: string;
}

export interface IMeetingDetailsAttendees {
  emailAddress: IMeetingEmailAddress;
  status: IMeetingResponse;
  type: string;
}

export interface IMeetingCoordinates {
  accuracy: string;
  altitude: string;
  altitudeAccuracy: string;
  latitude: string;
  longitude: string;
}

export interface IMeetingAddress {
  city: string;
  countryOrRegion: string;
  postalCode: string;
  state: string;
  street: string;
}
export interface IMeetingDetailsOnlineMeeting {
  joinUrl: string;
  dialInNumber: string;
}

export enum EMeetingStatus {
  accepted = 'Accepted',
  tentative = 'tentativelyAccepted',
  notResponded= 'notResponded',
  organizer= 'Organizer',
}

export enum EMeetingSort {
  accepted = 'accepted',
  tentative = 'tentativelyAccepted',
  notResponded= 'notResponded',
  organizer= 'organizer',
  allDay = 'isAllDay',
  canceled = 'isCancelled'
}

export enum EMeetingType {
  teams = 'teamsForBusiness',
  skype = 'skypeForBusiness',
  zoom = 'zoom',
  webex = 'webex',
  other = 'other'
}

